<template>
  <div>
    <b-card no-body class="p-2 container-card">
      <b-row>
        <b-col cols="12" class="px-2">
          <div>
            <b-row class="row justify-content-between mr-1 ml-1">
              <div
                class="
                  d-flex
                  flex-wrap
                  align-items-start
                  horoscope-type-filter-container
                  justify-content-start
                "
              >
                <div class="mr-1 ml-1 mb-1">
                  <label>{{ "Expired Status" }} </label>
                  <b-form-checkbox
                    v-model="formStatus.statusExpired"
                    field-value="true"
                    class="custom-control-success custom-toggle"
                    name="check-button"
                     @input="(option) => onSelectFilter('expired_status', option == true ? 1 : 2)"
                    switch
                  >
                    <span class="switch-icon-left toggle-text">{{
                      "Filter"
                    }}</span>
                    <span class="switch-icon-right toggle-text">{{
                      "Not Filter"
                    }}</span>
                  </b-form-checkbox>
                </div>
              </div>
              <div class="d-flex flex-wrap  align-items-end justify-content-end">
                <div class="mr-1 ml-1 mb-1">
                  <v-select
                    id="privilege-type-status"
                    v-model="formStatus.status"
                    class="v-select-filter bg-dropdown"
                    :class="
                      formStatus.status ? 'v-select-filter-selected' : null
                    "
                    placeholder="Status"
                    :options="statusOption"
                    @input="(option) => onSelectFilter('status', option)"
                  />
                </div>
                <div class="search-container mb-1">
                  <search :on-search-input="onSetValueSearch" />
                </div>
              </div>
            </b-row>
          </div>
        </b-col>
        <b-col cols="12" class="mb-1">
          <overlay-loading :loading="loading.tableData">
            <template #content>
              <!-- <b-table
                :key="tableModeReorder + keyChange"
                v-sortable-row="sortableRowOptions"
                :fields="fields"
                :items="inventoryManageTable.payload"
                responsive
                bordered
                borderless
                sticky-header
                show-empty
                no-local-sorting
                class="default-static-table inventory-manage"
                :class="tableModeReorder ? 'table-reorder' : null"
              > -->
              <b-table
                :key="tableModeReorder + keyChange"
                v-sortable-row="sortableRowOptions"
                :fields="fields"
                :items="inventoryManageTable.payload"
                responsive
                bordered
                borderless
                sticky-header
                show-empty
                no-local-sorting
                class="default-static-table-vertical inventory-manage"
                :class="tableModeReorder ? 'table-reorder' : null"
              >
                <template #head(image_url)="data">
                  <div class="text-center">
                    {{ data.field.label }}
                  </div>
                </template>
                <template #cell(stock_mode)="data">
                  <div
                    class="inventory-stock-mode"
                    :class="resolveStockModeClass(data.item.stock_mode)"
                  >
                    {{ resolveStockModeLabel(data.item.stock_mode) }}
                  </div>
                </template>
                <template #head(expired_alert)="data">
                  <div class="text-center">
                    {{ data.field.label }}
                  </div>
                </template>
                <template #cell(expired_alert)="data">
                  <div
                    class="inventory-Expired-Alert"
                    :class="resolveExpiredAlertClass(data.item.expired_status)"
                    v-if="formStatus.expiredStatus == true"
                  >
                    {{ resolveExpiredAlertLabel(data.item.expired_status) }}
                  </div>
                  <div v-else>
                    <span>{{"-"}}</span>
                  </div>
                </template>
                <template #cell(image_url)="data">
                  <div class="d-flex justify-content-center align-item-center">
                    <img
                      :src="data.item.privilege.image_url || DefaultImg"
                      class="inventory-image-column"
                    />
                  </div>
                </template>
                <template #cell(nameTh)="data">
                  <div class="inventory-name">
                    <b>En: </b>{{ data.item.privilege.name_en }}
                  </div>
                  <div class="inventory-name">
                    <b>Th: </b>{{ data.item.privilege.name_th }}
                  </div>
                </template>
                <template #cell(privilege_type)="data">
                  <div>
                    {{ data.item.privilege.type_desc }}
                  </div>
                </template>
                <template #cell(total_assign_inv)="data">
                  <div class="text-center">
                    {{ data.value }}
                  </div>
                </template>
                <template #cell(updatedtime)="data">
                  <div class="w-nowrap">
                    {{ resolveDateWithSeperator(data.value) }}
                  </div>
                </template>
                <template #cell(status)="data">
                  <div class="d-flex align-items-center">
                    <feather-icon
                      icon="CircleIcon"
                      class="mr-2"
                      :class="resolveStatusClass(data.item.privilege.status)"
                    />

                    <span>{{
                      resolveStatusLabel(data.item.privilege.status)
                    }}</span>
                  </div>
                </template>
                <template #cell(actions)="data">
                  <action-group
                    :resolve-action="resolveMappingTableAction"
                    :set-action-list="inventoryManageActionList"
                    :item-data="data"
                  />
                </template>
                <template #table-busy>
                  <overlay-loading :loading="true" />
                </template>
                <template #empty>
                  <card-no-item :text-no-img="'Item Not Found'" />
                </template>
              </b-table>
            </template>
          </overlay-loading>
        </b-col>
        <b-col cols="12">
          <pagination-with-reorder
            entity-editable
            reordering
            :pagination="pagination"
            @reorder="onClickReorder"
            @entityChange="onFilterEntity"
            @pageChange="onPageChange"
          />
        </b-col>
      </b-row>
    </b-card>
    <reorder-modal
      v-if="modalType.reorder"
      :current-index="currentIndex"
      :reorder-action="reorderInventoryManage"
      @onCloseModal="onCloseModalInventoryManage"
    />
    <assign-inventory-modal
      v-if="modalType.assignInventory"
      :privilege-obj="privilegeSelect"
      @onCloseModal="onCloseModalInventoryManage"
      @onSelectAssignInventory="onSelectAssignInventory"
    />
    <manage-stock-reward-modal
      v-if="modalType.manageStockReward"
      :reward-detail="rewardSelect"
      @onCloseModal="onCloseModalInventoryManage"
      @onAddPrivilege="onAddPrivilegeToInventory"
    />
    <manage-stock-coupon-external-modal
      v-if="modalType.manageStockCouponExternal"
      :reward-detail="rewardSelect"
      @onCloseModal="onCloseModalInventoryManage"
      @onAddPrivilege="onAddPrivilegeToInventory"
    />
  </div>
</template>

<script>
import {
  BCol,
  BCard,
  BTable,
  BFormCheckbox,
  BRow,
  BSpinner,
} from "bootstrap-vue";
import ActionGroup from "@/views/components/table-action-group/ActionGroup.vue";
import CardNoItem from "@core/components/card-no-item/CardNoItem.vue";

import Search from "@/views/components/search/Search.vue";
import vSelect from "vue-select";
import PaginationWithReorder from "@/views/components/pagination/PaginationWithReorder.vue";
import Sortable from "sortablejs";
import ReorderModal from "@/@core/components/reorder-modal/ReorderModal.vue";
import DefaultImg from "@/assets/images/icons/no-img-square.jpg";
import ManageStockRewardModal from "./components/ManageStockRewardModal.vue";
import ManageStockCouponExternalModal from "./components/ManageStockCouponExternalModal.vue";
import AssignInventoryModal from "../../privilege/privilege-list/components/AssignInventoryModal.vue";
import useInventoryManageMaster from "./hooks/useInventoryManageMaster";

const createSortable = (el, options, vnode) =>
  Sortable.create(el, {
    ...options,
  });

const sortableRow = {
  name: "sortableRow",
  bind(el, binding, vnode) {
    const table = el;
    table._sortable = createSortable(
      table.querySelector("tbody"),
      binding.value,
      vnode
    );
  },
};
export default {
  directives: {
    sortableRow,
  },
  components: {
    BCol,
    BCard,
    BTable,
    BFormCheckbox,
    BRow,
    BSpinner,
    CardNoItem,
    ActionGroup,
    Search,
    vSelect,
    PaginationWithReorder,
    ReorderModal,
    ManageStockRewardModal,
    ManageStockCouponExternalModal,
    AssignInventoryModal,
  },
  setup() {
    const {
      pagination,
      rewardSelect,
      formStatus,
      fields,
      statusOption,
      loading,
      inventoryManageTable,
      inventoryManageActionList,
      sortableRowOptions,
      tableModeReorder,
      keyChange,
      reorderInventoryManage,
      onClickReorder,
      currentIndex,
      modalType,
      resolveMappingTableAction,
      resolveStatusLabel,
      resolveStatusClass,
      onCloseModalInventoryManage,
      resolveStockModeClass,
      resolveStockModeLabel,
      resolveDateWithSeperator,
      onPageChange,
      onFilterEntity,
      onSetValueSearch,
      onSelectFilter,
      privilegeSelect,
      onSelectAssignInventory,
      onAddPrivilegeToInventory,
      resolveExpiredAlertLabel,
      resolveExpiredAlertClass,
    } = useInventoryManageMaster();
    return {
      pagination,
      DefaultImg,
      rewardSelect,
      formStatus,
      fields,
      statusOption,
      loading,
      inventoryManageTable,
      inventoryManageActionList,
      sortableRowOptions,
      tableModeReorder,
      keyChange,
      currentIndex,
      modalType,
      resolveMappingTableAction,
      resolveStatusLabel,
      resolveStatusClass,
      reorderInventoryManage,
      onClickReorder,
      onCloseModalInventoryManage,
      resolveStockModeClass,
      resolveStockModeLabel,
      resolveDateWithSeperator,
      onPageChange,
      onFilterEntity,
      onSetValueSearch,
      onSelectFilter,
      privilegeSelect,
      onSelectAssignInventory,
      onAddPrivilegeToInventory,
      resolveExpiredAlertLabel,
      resolveExpiredAlertClass,
    };
  },
};
</script>

<style scoped>
@import "~@/assets/css/pages/default-static-table.css";
@import "~@/assets/css/override-styles/status.css";
@import "~@/assets/css/pages/inventory/inventory-manage.css";
@import "~@/assets/css/override-styles/dynamic-fields.css";
</style>
